import {
  getRequest,
  getRequestWithQuery,
} from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
import { ApiResponse, UpdateCategoryResponse, Updates } from "../../types";

const api = getApiWithVersion(API_VERSION.V1);

export interface Update {
  getUpdateList(
    page: number,
    limit: number,
    category?: string | null
  ): Promise<ApiResponse<Updates>>;

  getEvent(slug: string): Promise<ApiResponse<Updates>>;

 getUpdateCategories(): Promise<ApiResponse<UpdateCategoryResponse>>;

}

export const update: Update = {
  /* ================= UPDATE LIST (WITH FILTER) ================= */
  getUpdateList(page, limit, category) {
    return getRequestWithQuery(api.UPDATE_LIST, {
      query: {
        page,
        limit,
        ...(category ? { category } : {}),
      },
    });
  },

  /* ================= UPDATE DETAIL ================= */
  getEvent(slug: string) {
    return getRequest(`${api.UPDATE_DETAIL}/${slug}`);
  },

  /* ================= CATEGORY DROPDOWN ================= */
  getUpdateCategories() {
    return getRequest(api.UPDATE_CATEGORIES);
  },
};
